import {PUBLISHED, UNPUBLISHED} from '@/utils/constants/jobs';

export default {
  setPublishedRecommendedJobsListState(context, jobs) {
    context[PUBLISHED] = jobs;
  },
  setUnpublishedRecommendedJobsListState(context, jobs) {
    context[UNPUBLISHED] = jobs;
  },
  mutateRecommendedJobsLoadingState(context, loading) {
    context.loading = loading;
  },
  mutateRecommendedJobsErrorState(context, error) {
    context.error = error;
  },
  mutateUnpublishedRecommendedJob(context, {id, payload}) {
    context[UNPUBLISHED] = context[UNPUBLISHED].map(item => {
      if (item.id === id) {
        item = {...item, ...payload};
      }

      return item;
    });
  },
  mutateRecommendedJob(context, {id, payload}) {
    context[PUBLISHED] = context[PUBLISHED].map(item => {
      if (item.id === id) {
        item = {...item, ...payload};
      }

      return item;
    });
    context[UNPUBLISHED] = context[UNPUBLISHED].map(item => {
      if (item.id === id) {
        item = {...item, ...payload};
      }

      return item;
    });
  },
  removeRecommendedJobFromList(context, id) {
    context[PUBLISHED] = context[PUBLISHED].filter(item => item.id !== id);
    context[UNPUBLISHED] = context[UNPUBLISHED].filter(item => item.id !== id);
  }
};
